export default __webpack_public_path__ + "static/media/call-voicemail.ea8ae591.svg";